module.exports = __webpack_public_path__ + "img/fbc0a4f.png";